import { connect } from 'react-redux';
import { FlexibleDateSelection } from 'shared/search/prepackage/FlexibleDateSelection';
import type { ApiQueryParams, Month, NumberRange, PaleState } from '@/interfaces';
import { actions } from '@/state/filterActions';

export interface TravelMonthsProps {
    months: Month[];
    duration?: NumberRange;
    toggleMonth: (month: Month) => void;
    changeDuration: (duration: NumberRange) => void;
    triggerFetch: (queryParam?: ApiQueryParams) => void;
}

export const TravelMonths = ({ months, duration, toggleMonth, changeDuration, triggerFetch }: TravelMonthsProps) => {
    const toggleMonthAndTriggerFetch = (month: Month): void => {
        toggleMonth(month);
        triggerFetch();
    };

    const changeDurationAndTriggerFetch = (duration: { from: number; to: number }): void => {
        changeDuration([duration.from, duration.to]);
        triggerFetch();
    };

    return (
        <FlexibleDateSelection
            travelMonths={months}
            duration={{ from: duration ? duration[0] : 5, to: duration ? duration[1] : 15 }}
            toggleMonth={toggleMonthAndTriggerFetch}
            setDuration={changeDurationAndTriggerFetch}
        />
    );
};

const mapStateToProps = (
    state: PaleState,
    { triggerFetch }: Pick<TravelMonthsProps, 'triggerFetch'>,
): Pick<TravelMonthsProps, 'months' | 'duration' | 'triggerFetch'> => ({
    months: state.filters.travelMonths,
    duration: state.filters.duration,
    triggerFetch: triggerFetch,
});

const mapDispatchToProps = {
    toggleMonth: actions.toggleTravelMonth,
    changeDuration: actions.changeDuration,
};

export default connect(mapStateToProps, mapDispatchToProps)(TravelMonths);
